export default "__VITE_ASSET__B$4XwtMM__"